import axios from 'axios'

export async function getJson(id) {
  return axios
    .get(`/sites/${id}.json`)
    .then(response => {
      return response.data
    })
    .catch(error => {
      console.log(error)
    })
}

export async function getGeoJson(id) {
  return axios
    .get(`/geoJson/${id}.json`)
    .then(response => response.data)
    .catch(error => console.log(error))
}
